import { createDarkFamilyShadows } from '../dark-family/create-shadows'

export const createShadows = () => createDarkFamilyShadows()
